import { CategoryLensChainLtoRow, LtoMetricName } from "@apiHooks/useHomeCategoryLensChainLtos";

export const KEY_METRIC_OPTIONS: { id: keyof CategoryLensChainLtoRow; title: string }[] = [
    { id: 'unbrandedPi', title: LtoMetricName.UnbrandedPi },
    { id: 'uniqueness', title: LtoMetricName.Uniqueness },
    { id: 'frequency', title: LtoMetricName.Frequency },
    { id: 'draw', title: LtoMetricName.Draw },
    { id: 'value', title: LtoMetricName.Value },
    { id: 'score', title: LtoMetricName.Score },
];